<template>
  <vz-switcher
    :modelValue="orderTypeValue"
    class="vz-personal-order-switcher"
    :items="orderTypesItems"
    tabs
    @update:modelValue="onChange"
  />
</template>

<script setup lang="ts">
import VzSwitcher from '~/components/ui-kit/vz-switcher.vue';
import {orderTypes} from '~/common/objects';
import {useOrderStore} from '~/stores/order';
import {OrderType} from '~/types/store';

const orderStore = useOrderStore()

const isMultiRequest = computed(() => {
  return orderStore.orderType === 'multi' && orderStore.multiOrder.selectedRequestId
})

const orderTypeValue = computed(() => {
  return isMultiRequest.value
    ? orderStore.multiOrder.selectedRequest?.meta?.type || 'individual'
    : orderStore.orderType
})

const orderTypesItems = computed(() => {
  return  orderTypes.map(item => ({
    ...item,
    title: item.value === 'individual' ? 'Стандартная заявка' : item.title,
    disabled: item.value === 'multi',
    disabledText: 'Вы уже в мультизаявке'
  }))
})

async function onChange(value: OrderType) {
  await orderStore.onOrderTypeChange(value)
  orderStore.multiOrder.selectedRequest.meta.type = value
}
</script>

<style lang="scss" scoped>

</style>
